import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import ReactEcharts from '../Echarts/Echarts';
import StyledTable from '../../../../../commons/styles/table';
import { Form, Select, Button, Tabs, Row, Col, Radio } from 'antd';

const { TabPane } = Tabs;

const Correction = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const option = {
    xAxis: {
      type: 'category',
      data: [0.0, 0.15, 0.3, 0.45, 0.6, 0.75, 1.0]
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: [2000, 3000, 4000, 5000, 6000, 7000],
        type: 'line'
      }
    ]
  };

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const columns = [
    {
      title: translation('Sample Name'),
      dataIndex: 'SampleName',
      key: 'SampleName'
    },
    {
      title: translation('Date'),
      dataIndex: 'Date',
      key: 'Date'
    },
    {
      title: translation('CH'),
      dataIndex: 'ch',
      key: 'ch'
    },
    {
      title: translation('Target Value'),
      dataIndex: 'Target Value',
      key: 'Target Value'
    },
    {
      title: translation('Disp .Value'),
      dataIndex: 'DV',
      key: 'DV'
    }
  ];
  const dataSource = [
    {
      key: '1',
      name: translation('Mike'),
      age: 32,
      address: translation('10 Downing Street')
    },
    {
      key: '2',
      name: translation('John'),
      age: 42,
      address: translation('10 Downing Street')
    }
  ];

  return (
    <div>
      <Form
        {...formItemLayout}
        layout="horizontal"
        name={translation('HeaderNumber_current')}
        style={{ margin: '19px', padding: '30px' }}
      >
        <Form.Item label={translation('HD')}>
          <Select style={{ width: 220 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label={translation('CH')}>
          <Select style={{ width: 220 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label={translation('Current Offset')}>
          <div>0.000000</div>
        </Form.Item>
        <Form.Item label={translation('Current Slope')}>
          <div>1.000000</div>
        </Form.Item>

        <Tabs defaultActiveKey="1" type="card">
          <TabPane tab={translation('Correction Data')} key={'CD'}>
            <div style={{ padding: '30px' }}>
              <Button type="primary" style={{ margin: '10px' }}>
                {translation('Start Measurement')}
              </Button>
              <Button type="primary" style={{ margin: '10px' }}>
                {translation('Calculation')}
              </Button>
              <div style={{ display: 'flex', flexDirection: 'column', margin: '10px' }}>
                <label>{translation('Correction Method')}</label>
                <Radio.Group>
                  <Radio value={'Offset'}>{translation('Offset')}</Radio>
                  <Radio value={'Offset+Slope'}>{translation('Offset+Slope')}</Radio>
                </Radio.Group>
              </div>
              <Row>
                <Col flex="auto">
                  <StyledTable size="small"
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    bordered
                  />
                </Col>
              </Row>
              <Button type="primary" style={{ margin: '10px' }}>
                {translation('Open the correction data')}
              </Button>
              <Button type="primary" style={{ margin: '10px' }}>
                {translation('Save a correction data file')}
              </Button>
            </div>
          </TabPane>
          <TabPane tab={translation('Correction Result')} key={'CR'}>
            <Row>
              <Col flex={3}>
                <Form
                  {...formItemLayout}
                  layout="horizontal"
                  name={translation('form1')}
                  style={{
                    margin: '19px',
                    padding: '30px'
                  }}
                >
                  <Form.Item label={translation('Corre. Method')}>
                    <div>R -</div>
                  </Form.Item>
                  <Form.Item label={translation('Number of data')}>
                    <div>SEC -</div>
                  </Form.Item>
                  <Form.Item label={translation('Offset')}>
                    <div>N -</div>
                  </Form.Item>
                  <Form.Item label={translation('Slope')}>
                    <div>GN -</div>
                  </Form.Item>
                </Form>
              </Col>
              <Col flex={3}>
                <Form
                  {...formItemLayout}
                  layout="horizontal"
                  name={translation('form2')}
                  style={{
                    margin: '19px',
                    padding: '30px'
                  }}
                  className="formComponent"
                >
                  <Form.Item label={translation('No')}>
                    <Select style={{ width: 220 }}>
                      <Select.Option value="01">01</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label={translation('Correction target')}></Form.Item>
                  <Form.Item label={translation('Display Value')}></Form.Item>
                  <Form.Item label={translation('Residual Error')}></Form.Item>
                </Form>
              </Col>
            </Row>
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              style={{ margin: '19px', padding: '30px' }}
              className="react_for_echarts"
            />
            <Button type="primary" style={{ margin: '10px' }}>
              {translation('Write By KB-30')}
            </Button>
          </TabPane>
        </Tabs>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Correction);
